export class PerformanceMonitor {
  private fpsHistory: number[] = [];
  private memoryWarnings = 0;

  constructor() {
    this.startMemoryCheck();
  }

  trackFPS(fps: number): void {
    this.fpsHistory.push(fps);
    if (this.fpsHistory.length > 60) {
      this.fpsHistory.shift();
    }
  }

  getAverageFPS(): number {
    if (this.fpsHistory.length === 0) return 0;
    return this.fpsHistory.reduce((a, b) => a + b, 0) / this.fpsHistory.length;
  }

  getMinFPS(): number {
    if (this.fpsHistory.length === 0) return 0;
    return Math.min(...this.fpsHistory);
  }

  private startMemoryCheck(): void {
    if (typeof performance === 'undefined' || !('memory' in performance)) return;

    const check = () => {
      const mem = (performance as { memory?: { usedJSHeapSize: number; jsHeapSizeLimit: number } }).memory;
      if (mem) {
        const usedMB = mem.usedJSHeapSize / 1024 / 1024;
        const limitMB = mem.jsHeapSizeLimit / 1024 / 1024;
        const usage = usedMB / limitMB;

        if (usage > 0.8) {
          this.memoryWarnings++;
          console.warn(`[Performance] High memory: ${usedMB.toFixed(1)}MB / ${limitMB.toFixed(1)}MB (${(usage * 100).toFixed(0)}%)`);
        }
      }
    };

    setInterval(check, 30000);
  }

  getStats(): { avgFPS: number; minFPS: number; memoryWarnings: number } {
    return {
      avgFPS: Math.round(this.getAverageFPS()),
      minFPS: Math.round(this.getMinFPS()),
      memoryWarnings: this.memoryWarnings,
    };
  }
}

export const perfMonitor = new PerformanceMonitor();
